import { useCallback, useMemo, useState } from 'react';
import { IFitoListSettings } from '../interfaces';

export const useFitoListReactQueryPagination = ({
  settings,
  enableForceRefresh,
  pageSize,
}: {
  settings: IFitoListSettings;
  enableForceRefresh: () => void;
  pageSize: number;
}) => {
  const [page, setPage] = useState(settings?.paginationSettings?.startAt ?? 1);
  const paginationQuery = useMemo(() => {
    if (settings.pagination) {
      if (
        settings.headerPagination?.take &&
        typeof settings.headerPagination?.skip !== 'undefined'
      ) {
        const { take, skip } = settings.headerPagination;
        return { take, skip: skip + (page - 1) * pageSize };
      }

      if (settings.paginationSettings) {
        const { pageField, sizeField } = settings.paginationSettings;
        return { [sizeField]: pageSize, [pageField]: page };
      } else {
        return { pageSize, page };
      }
    }

    return {};
  }, [page, pageSize, settings.pagination, settings.paginationSettings]);

  const onNextPage = useCallback(() => {
    setPage(page + 1);
    enableForceRefresh();
  }, [setPage, page]);
  const onPreviousPage = useCallback(() => {
    setPage(page - 1);
    enableForceRefresh();
  }, [setPage, page]);

  return { paginationQuery, page, setPage, onNextPage, onPreviousPage };
};
